import { EventShim, EventTagerShim } from "../EventTaget/index";
import { deepFindLog, now, noop } from "../utils/index";
import eventCatch from "../eventCatch/index";

interface wilAttrubuteOption {
  "data-log-view": string;
  "data-log-outview": string;
  "data-log-click": string;
  "data-log-render": string;
  "data-log-extra": string;
  "data-log-view-stay": string;
  [key: string]: string;
}
interface wilClickOption {
  attribute?: wilAttrubuteOption;
}

const logAttributeMap: wilAttrubuteOption = {
  "data-log-view": "data-log-view",
  "data-log-click": "data-log-click",
  "data-log-extra": "data-log-extra",
  "data-log-render": "data-log-render",
  "data-log-outview": "data-log-outview",
  "data-log-view-stay": "data-log-view-stay"
};

interface sendLog {
  (log: LogEvent): void;
}

type Info = {
  type: string;
  duration?: any;
  time?: any;
  startTime?: any;
  endTime?: any;
};

export class LogEvent {
  log: Object;
  path: Array<Object>;
  target: Element;
  time: number;
  type: string;
  constructor(target: Element, logPath: Array<Object>, info: Info) {
    this.type = info.type;
    Object.assign(this, info);
    this.log = Object.assign({}, ...[...logPath].reverse());
    this.path = logPath;
    this.target = target;
    this.time = now();
  }
}

class WilClickEventEvent extends EventShim {
  from: MouseEvent;
  constructor(type: string, event: MouseEvent) {
    super(type);
    this.from = event;
  }
}

class WilLogEvent extends EventShim {
  from: LogEvent;
  constructor(type: string, event: LogEvent) {
    super(type);
    this.from = event;
  }
}

class WilClickEventTaget extends EventTagerShim {
  config: wilAttrubuteOption;
  intersectionObserver?: IntersectionObserver;
  mutationObserver?: MutationObserver;
  constructor(fn: sendLog, option: wilClickOption = {}) {
    super();
    this.config = Object.assign({}, logAttributeMap, option.attribute);
    this.init(fn);
  }

  init(fn: sendLog) {
    // 派发 click 事件
    eventCatch(event => {
      this.dispatchEvent(new WilClickEventEvent("clickEvent", event));
    });

    // 监听 click
    this.addEventListener("clickEvent", (event: WilClickEventEvent) => {
      this.handleClickEvent(event);
    });

    // 监听 发出的 logEvent
    this.listenLogEvent(fn);

    // ios click 在 document 上代理 不生效 bug
    this.fixIOSSafari();
  }

  fixIOSSafari() {
    if (document.body) {
      for (let i = 0, nodes = document.body.childNodes; i < nodes.length; i++) {
        const node = nodes[i];
        if (node instanceof Element && node.nodeType === 1) {
          (node as HTMLElement)["onclick"] = noop;
        }
      }
    } else {
      document.addEventListener("DOMContentLoaded", function() {
        for (
          let i = 0, nodes = document.body.childNodes;
          i < nodes.length;
          i++
        ) {
          const node = nodes[i];
          if (node instanceof Element && node.nodeType === 1) {
            (node as HTMLElement)["onclick"] = noop;
          }
        }
      });
    }
  }

  handleClickEvent(e: WilClickEventEvent) {
    const event = e.from;
    this.handleMouseEvent(event);
  }

  handleMouseEvent(e: MouseEvent) {
    const targetElement = e.target;

    if (
      targetElement &&
      (targetElement instanceof HTMLElement ||
        targetElement instanceof SVGElement) &&
      targetElement.nodeType === 1 &&
      e.type == "click"
    ) {
      const attributeName = this.config["data-log-click"];
      const attributeExtraName = this.config["data-log-extra"];
      const log = deepFindLog(targetElement, attributeName, attributeExtraName);

      if (log !== null) {
        this.dispatchEvent(
          new WilLogEvent(
            "logEvent",
            new LogEvent(targetElement, log, { type: "click" })
          )
        );
      }
    }
  }

  listenLogEvent(fn: sendLog) {
    this.addEventListener("logEvent", (e: WilLogEvent) => {
      const event = e.from;
      fn(event);
    });
  }
}

export default WilClickEventTaget;
